import type { Column } from 'react-data-grid';
import React, { useEffect, useRef, useState } from 'react';
import { getDBWorkspaceSpent, getDBWorkspaceSpentDate, getDecodedToken, getSector, jobSearchForDBWorkspace } from '../../../service/service';
import './CostSummary.scss';
import '../Summary/Summary.scss';
import { CustomizedDataGrid } from '../../customized_data_grid';
import { Grid } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import Loader from '../../Loader/loader';
import useStyles from '../../jobs/jobs_styles';
import { dashboardUrl,databricksurl } from '../../../service/config';

import axios from 'axios';
const Workspace = ({ fromDateTime, sectorFilter, setFromDateTime, dateSelect }: any) => {
	interface Row {
		workspace_name: string;
		cluster_type: string;	
		cluster_name: string;
		total_dbus: string;
		total_DBU_cost: string;
		total_compute_cost: string;
	}

	function getColumns(): Array<Column<Row>> {
		return [
			{
				key: 'workspace_name',
				name: 'Workspace',
				formatter(props) {
					return <div title={props.row.workspace_name} className='has-ellipsis'>{props.row.workspace_name}</div>
				},
				minWidth: 120
			},

			{
				key: 'cluster_type',
				name: 'Cluster Type',
				minWidth: 120,
				width: 120,
				formatter(props) {
					return <div title={props.row.cluster_type} className='has-ellipsis'>{props.row.cluster_type ? props.row.cluster_type : '--'}</div>
				},
			},
			{
				key: 'cluster_name',
				name: 'Cluster Name',
				formatter(props) {
					return <div title={props.row.cluster_name} className='has-ellipsis'>{props.row.cluster_name ? props.row.cluster_name : '--'}</div>
				},
				minWidth: 120
			},

			{
				key: 'total_dbus',
				name: 'Total DBU',
				minWidth: 120
			},
			{
				key: 'total_DBU_cost',
				name: 'Total DBU Cost',
				minWidth: 120
			},
			{
				key: 'total_compute_cost',
				name: 'Total Compute Cost',
				minWidth: 120
			}
		];
	}

	const defaultColumnNames = [
		'Workspace',
		'Cluster Type',
		'Cluster Name',
		'Total DBU',
		'Total DBU Cost',
		'Total Compute Cost'
	];

	const [workspaceSpentList, setworkspaceSpentList] = useState<Row[]>([]);
	const [sortingInfo, setSortingInfo] = useState({ sortBy: '', sortDir: '' });
	const [paginationData, setPaginationData] = useState({ totalPages: 0, totalCount: 0 });
	const [page, setPage] = useState(1);
	const [pageSize, setPageSize] = useState(100);

	// Date range
	const [filterData, setFilterData] = useState<Row[]>([]);
	const [searchDetails, setFilterSearchInfo] = useState([]);
	const [loading, setLoading] = useState(false);
	const [filterInfo, setFilterInfo] = useState([]);
	const [searchParams, setSearchParams] = useSearchParams();
	const [error, setError] = useState<string | null>(null);

	// sector filter
	const [sharedValue, setSharedValue] = useState('');
	const updateSharedValue = (newValue: any) => {
		setSharedValue(newValue);
	};

	const handlePageChange = (event: any, value: number) => {
		setLoading(true);
		let nextPage = value.toString(); 
		if(event.target.dataset.testid == "LastPageIcon" || event.target.dataset.testid == "FirstPageIcon"){
			nextPage = value.toString(); 
		}
		else if(event.target.dataset.testid == "NavigateBeforeIcon"){
			nextPage = (Number(page) - 1).toString();
		}
		else if (nextPage === event.target.textContent) { 
			nextPage = event.target.textContent;
		} else {
			nextPage = (Number(page) + 1).toString();
		}
		const promise1 = DBWorkspaceSpentListingFunc(
			parseInt(nextPage),
			pageSize,
			sortingInfo,
			fromDateTime,
			fromDateTime,
			parseFilter(filterInfo),
			sectorFilter
		).catch((error) => {
			setLoading(false);
			setError(error); // Set error state when API call fails
		});
		Promise.all([promise1]).then((values) => {
			setLoading(false);
		});
	};

	const handlepageSizeChange = (event: any) => {
		setLoading(true);
		const promise1 = DBWorkspaceSpentListingFunc(
			'1',
			event.target.value,
			sortingInfo,
			fromDateTime,
			fromDateTime,
			parseFilter(filterInfo),
			sectorFilter
		).catch((error) => {
			setLoading(false);
			setError(error); // Set error state when API call fails
		});
		Promise.all([promise1]).then((values) => {
			setLoading(false);
		});
	};

	const handleSorting = (sortingInfo: any) => {
		setLoading(true);
		const promise1 = DBWorkspaceSpentListingFunc(
			page,
			pageSize,
			sortingInfo,
			fromDateTime,
			fromDateTime,
			parseFilter(filterInfo),
			sectorFilter
		).catch((error) => {
			setLoading(false);
			setError(error); // Set error state when API call fails
		});
		Promise.all([promise1]).then((values) => {
			setLoading(false);
		});
	};

	const resetSearchParams = () => {
		if (searchParams.has('fromDate') || searchParams.has('toDate')) {
			searchParams.delete('status');
			searchParams.delete('scheduleDate');
			searchParams.delete('fromDate');
			searchParams.delete('toDate');
			setSearchParams(searchParams);
		}
	};

	const handleFilter = (filterInfo: any) => {
		resetSearchParams();
		setFilterInfo(filterInfo);
		setLoading(true);
		const promise1 = DBWorkspaceSpentListingFunc(
			1,
			pageSize,
			sortingInfo,
			fromDateTime,
			fromDateTime,
			parseFilter(filterInfo),
			sectorFilter
		).catch((error) => {
			setLoading(false);
			setError(error); // Set error state when API call fails
		});
		Promise.all([promise1]).then((values) => {
			setLoading(false);
		});
	};

	async function jobSearchForDBWorkspaceFunc(searchDetails: any, jobFilterInfo: any, searchQuery: any, searchField: any) {
		const res = await jobSearchForDBWorkspace(searchDetails, jobFilterInfo, fromDateTime, fromDateTime, searchField, searchQuery);
		if (res.success) {
			setFilterSearchInfo(res.data);
		}
	}

	const handleSearch = (searchDetails: any, searchField: any, searchQuery:any) => {
		jobSearchForDBWorkspaceFunc(searchDetails, parseFilter(filterInfo, 'name'), searchQuery, searchField);
	};
	const parseFilter = (filterInfo: any, name?: string) => {
		// Call only filterable columns and reset the filtering in case of wrong/empty column
		const parsedFilter: any = {};
		Object.keys(filterInfo).forEach((key: any) => {
			if (key !== name && filterInfo[key] && filterInfo[key].length) {
				parsedFilter[key] = filterInfo[key];
			}
		});
		return parsedFilter;
	};

	const formatColumnFilterOptions = (apiData: any) => {
		const filterOptions: any = {
			workspace_name: [],
			cluster_type: [],
			cluster_name: [],
			total_count: [],
			total_DBU_cost: []
		}
		apiData.filter((job: any) => {
			Object.entries(job).forEach(([key, value]) => {
				if (key == 'workspace_name' && !filterOptions.workspace_name.includes(value)) {
					filterOptions.workspace_name.push(value);
				} else if (key == 'total_count' && !filterOptions.total_count.includes(value)) {
					filterOptions.total_count.push(value);
				} else if (key == 'cluster_type' && !filterOptions.cluster_type.includes(value)) {
					filterOptions.cluster_type.push(value);
				} else if (key == 'cluster_name' && !filterOptions.cluster_name.includes(value)) {
					filterOptions.cluster_name.push(value);
				} else if (key == 'total_DBU_cost' && !filterOptions.total_DBU_cost.includes(value)) {
					filterOptions.total_DBU_cost.push(value);
				}
			});
		});
		return filterOptions;
	}

	// Initial load API call
	async function DBWorkspaceSpentListingFunc(
		pageNumber: any,
		size: any,
		sortingInfo: any,
		fromDateTime: any,
		toDateTime: any,
		jobFilterInfo: any,
		sector: any
	) {
		try {
			// Check if there's a stored sector filter in localStorage
			let storedSectorFilter = localStorage.getItem('dcs-summary-sector-filter')
				? JSON.parse(localStorage.getItem('dcs-summary-sector-filter') ?? '')
				: null;
			if (storedSectorFilter) {
				sector = storedSectorFilter;
			}
	
			setLoading(true);
	
			// Make a call to Databricks
			const databricksresponse = await axios.get(`${databricksurl}`);
		
			console.log('Databricks Call initiated', databricksresponse);
	
			if (databricksresponse && databricksresponse.status) {
				// Fetch the workspace spent data
		const res = await getDBWorkspaceSpent(
			pageNumber.toString(),
			size.toString(),
			sortingInfo,
			jobFilterInfo,
			fromDateTime,
			fromDateTime,
			sector
		);
		if (res.success) {
			const addDollar = res.data.result.map((item: any) => ({
					...item,
					// total_DBU_cost: `${
					// 	item.total_DBU_cost !== null && item.total_DBU_cost !== undefined
					// 		? `${formatNumber(item.total_DBU_cost)}`
					// 		: 0.00
					// }`,
					// total_compute_cost: `${
					// 	item.total_compute_cost !== null && item.total_compute_cost !== undefined
					// 		? `${formatNumber(item.total_compute_cost)}`
					// 		: 0.00
					// }`,
					// total_dbus: `${
					// 	item.total_dbus !== null && item.total_dbus !== undefined ? `${formatNumber(item.total_dbus)}` : 0.00
					// }`
					total_DBU_cost: formatNumber(item.total_DBU_cost),
					total_compute_cost: formatNumber(item.total_compute_cost),
					total_dbus: formatNumber(item.total_dbus)
			}));
			setworkspaceSpentList(addDollar);
			setPaginationData(res.data.page);
			setFilterData(res.data.filterOptions);
			setFilterInfo(jobFilterInfo);
			setPage(pageNumber);
			setPageSize(size);
			setFromDateTime(localStorage.getItem('processedDate'));
			setSortingInfo(sortingInfo);
					setError(null);
		}else {
			setError('Failed to fetch data');
		}
			} else {
				setError('Cluster Inactive');
	}
		} catch (error) {
		setError('Failed to fetch data');
	}
		setLoading(false);
	}
	

		// User select specific date API call
		async function DBWorkspaceSpentListingDateFunc(
		pageNumber: any,
		size: any,
		sortingInfo: any,
		fromDateTime: any,
		toDateTime: any,
		jobFilterInfo: any,
		sector: any
	) {
		setLoading(true);
		try {
			
		let storedSectorFilter = localStorage.getItem('dcs-summary-sector-filter')
		? JSON.parse(localStorage.getItem('dcs-summary-sector-filter') ?? '')
		: null;
		if (storedSectorFilter) {
			sector = storedSectorFilter;
		}
		const res = await getDBWorkspaceSpentDate(
			pageNumber.toString(),
			size.toString(),
			sortingInfo,
			jobFilterInfo,
			fromDateTime,
			fromDateTime,
			sector
		);
		if (res.success) {
			const addDollar = res.data.result.map((item: any) => ({
				
					...item,
					// total_DBU_cost: `${
					// 	item.total_DBU_cost !== null && item.total_DBU_cost !== undefined
					// 		? `${formatNumber(item.total_DBU_cost)}`
					// 		: 0.00
					// }`,
					// total_compute_cost: `${
					// 	item.total_compute_cost !== null && item.total_compute_cost !== undefined
					// 		? `${formatNumber(item.total_compute_cost)}`
					// 		: 0.00
					// }`,
					// total_dbus: `${
					// 	item.total_dbus !== null && item.total_dbus !== undefined ? `${formatNumber(item.total_dbus)}` : 0.00
					// }`
					total_DBU_cost: formatNumber(item.total_DBU_cost),
					total_compute_cost: formatNumber(item.total_compute_cost),
					total_dbus: formatNumber(item.total_dbus)
			}));
			setworkspaceSpentList(addDollar);
			setPaginationData(res.data.page);
			setFilterData(res.data.filterOptions);
			// setFilterData(formatColumnFilterOptions(addDollar));
			setFilterInfo(jobFilterInfo);
			setPage(pageNumber);
			setPageSize(size);
			setSortingInfo(sortingInfo);}else {
			setError('Failed to fetch data'); // Set the error state if API call fails
		}
	}
	 catch (error) {
		setError('Failed to fetch data'); // Set the error state if API call fails
	}
			setLoading(false);
		}


		function formatNumber(number:any) {
			if (number != null && !isNaN(number)) {
				return Number(number).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
			} else {
				return "0.00";
			}
		}

	// API
	useEffect(() => {
		setError(null);
		DBWorkspaceSpentListingFunc(page, pageSize, sortingInfo, fromDateTime, fromDateTime, [], sectorFilter).catch(
			(error) => {
				setError(error); // Set error state when API call fails during initial load
			}
		);
	}, [sectorFilter]);

	useEffect(() => {
		setError(null);
		if (dateSelect != 0) {
			DBWorkspaceSpentListingDateFunc(
				"1",
				pageSize,
				sortingInfo,
				fromDateTime,
				fromDateTime,
				[],
				sectorFilter
			);
		}
	}, [dateSelect]);

	return (
		<div className="react-div cost-sum-table-wrap">
			<p className="databricks_title">Workspace Spent Utilization</p>
			{error == 'Cluster Inactive' ? (
					// Display error message or handle error condition in UI
					<div
						style={{
							color: '#e5e5e5',
							marginLeft: '25%',
							padding: '10px',
							fontWeight: 500,
							gridColumn: '1 / -1'
						}}
					>
						Cluster is Inactive, it will take Max 2mins to start, Please try again later
					</div>
				) :error? (
					// Display error message or handle error condition in UI
					<div
						style={{
							color: '#e5e5e5',
							marginLeft: '25%',
							padding: '10px',
							fontWeight: 500,
							gridColumn: '1 / -1'
						}}
					>
						Error occurred while fetching data. Please try again.
					</div>
				) : (
			<Grid className="costSummary_tabledata">
				{!loading ? (<>
					<CustomizedDataGrid
						tableColumns={getColumns()}
						tableData={workspaceSpentList}
						tableType="DBWorkspace"
						defaultColumnNames={defaultColumnNames}
						onSorting={handleSorting}
						currSorting={sortingInfo}
						filterDataOptions={filterData}
						onFilterCheck={handleFilter}
						currFilter={filterInfo}
						searchDataValues={searchDetails}
						onFilterSearch={handleSearch}
						page={page}
						pageSize={pageSize}
						paginationData={paginationData}
						listLength={workspaceSpentList.length}
						handlepageSizeChange={handlepageSizeChange}
						handlePageChange={handlePageChange}
						isDateRangeFilter={false}
						isDisabled={false}
					/>
					{workspaceSpentList?.length ? <p className="disclaimer disclaimer5">Note: Double hyphens (--) indicate that the field has no data.</p> : ''}
					</>
				) : (
					<Loader />
				)}
			</Grid>
				)}
		</div>
	);
};

export default Workspace;
